import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, palette, fontSizes,
}: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.625rem',
    padding: '1.25rem 2.5rem 0.625rem',
    borderRadius: '0.75rem',
    background: 'linear-gradient(145.59deg, #d7faff 0%, #fffbee 100%)',
    [breakpoints.up('md')]: {
      position: 'relative',
      alignItems: 'flex-start',
      paddingLeft: '10.875rem',
      paddingBottom: '1.25rem',
      borderRadius: '1rem',
    },
  },
  image: {
    width: '7.75rem',
    height: 'auto',
    objectFit: 'contain',
    [breakpoints.up('md')]: {
      position: 'absolute',
      top: '1.25rem',
      left: '2.5rem',
    },
  },
  title: {
    margin: 0,
    fontSize: '1.125rem',
    lineHeight: 1.2,
    [breakpoints.up('md')]: {
      fontSize: '1.75rem',
      lineHeight: 1.3,
    },
  },
  text: {
    margin: 0,
    fontSize: fontSizes.xs,
    lineHeight: 1.2,
  },
  disclaimer: {
    margin: 0,
    fontSize: '0.6875rem',
    lineHeight: 1.1,
    color: 'rgba(34, 34, 34, 0.5)',
  },
  button: {
    '&&': {
      padding: '0.625rem',
      border: `1px solid ${palette.text.primary}`,
      borderRadius: 60,
      color: palette.text.primary,
      fontSize: fontSizes.sm,
      lineHeight: 1.4,
    },
  },
  textAligned: {
    textAlign: 'center',
    [breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
}));
